import React, { Component } from 'react';
import * as Constants from '../../../common/Global/constants';
import {getLocalStorageVariables, handleTokenExpiry, isEmptyVariable} from '../../../common/Global/commonFunctions';
import {Modal} from 'react-bootstrap';
import {DialogSaveButton} from '../../../common/Global/globalStyles.style';
import AlertDialog from '../../../common/AlertDialog';

let userDetails = getLocalStorageVariables();

class HeadingDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            showLoader:false,

            formErrors:{},
            submitClickedAtleastOnce:false,
            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",
            selectedOption:""
        }
        userDetails = getLocalStorageVariables();
    }

    componentDidMount(){
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && 
        this.props.showHeadingTypeDialog){
            if(this.props.isEdit){
                this.setState({
                    componentDidMountFlag:false,
                    showLoader:false,
    
                    formErrors:{},
                    submitClickedAtleastOnce:false
                })
            }else{
                this.setState({
                    componentDidMountFlag:false,
                    showLoader:false,
    
                    formErrors:{},
                    submitClickedAtleastOnce:false,
                    selectedOption:""
                })
            }
        }
    }

    handleCheck = (e) =>{
        let selectedOption = e.target.value;
        let FormErrorsTemp = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['option'] = "";
        }
        
        this.setState({
            selectedOption
        })
    }

    handleCreateDialogClose = () =>{
        this.props.handleDialogClose();
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

    handleSave = () => {
        this.setState({
            showLoader:true,
            submitClickedAtleastOnce:true,
        });
        
        let isError = false;
        let FormErrorsTemp = {};
        if(isEmptyVariable(this.state.selectedOption)){
            isError = true;
            FormErrorsTemp['option'] = "Please select the option";
        }

        if(isError){
            this.setState({
                formErrors:FormErrorsTemp,
                showLoader:false
            });
        }else{
            fetch(Constants.UpdateCheckListTitleType,
                {
                    method: "POST",
                    mode:'cors',
                    body: new URLSearchParams({
                        email:userDetails.email,
                        accessToken:userDetails.accessToken,
                        titleType:this.state.selectedOption,
                        checkListHeadingId:this.props.checkListHeadingId,
                    })
                })
                .then(response => { return response.json(); } )
                .then(data =>
                {
                    if(handleTokenExpiry(data.responseCode)) return;
                    else if(data.responseCode === Constants.CODE_SUCCESS){
                        this.setState({
                            showLoader:false,
                            formErrors:{},
                        },() => {
                            this.props.handleDialogClose(this.state.selectedOption);
                        });
                    }else{
                        //TODO show alert dialog
                        this.setState({
                            showLoader:false,
                            showAlertDialogInfo:true,
                            alertDialogMessageInfo:data.responseMessage
                        })
                    }
        
                });
            
        }
    }

    render() {
        return(
            <>
            <Modal className="custom-dialog" show={this.props.showHeadingTypeDialog} backdrop="static">
                <Modal.Header>
                    <h5>{"Choose Heading Type"}</h5>
                    <button 
                        onClick={this.handleCreateDialogClose}
                        type="button" data-dismiss="modal">
                        <span class="material-icons">close</span>
                    </button>
                </Modal.Header>
                <hr />
                <div class="modal-body">
                    <div className="radio-group radio-group-block">
                        <div className="radio-btn radio-btn-name">
                            <input 
                                type="radio"
                                name="option"
                                id="useProcessHeading"
                                onChange={this.handleCheck}
                                value="nodeName"
                                checked={this.state.selectedOption === "nodeName"}
                            />
                            <label for="useProcessHeading">Use Process Heading (Use already created processes as heading to group the task for checklist)</label>
                        </div>
                        <div className="radio-btn radio-btn-name">
                            <input 
                                type="radio"
                                name="option"
                                id="customizedHeading"
                                onChange={this.handleCheck}
                                value="customName"
                                checked={this.state.selectedOption === "customName"}
                            />
                            <label for="customizedHeading">Customized Heading</label>
                        </div>
                    </div>
                    {
                        !isEmptyVariable(this.state.formErrors['option']) &&
                        <span class="cm-error">{this.state.formErrors['option']}</span>
                    }
                    <div class="modal-close-save">
                        <div class="close-save-col">
                            <button onClick={this.handleCreateDialogClose} type="button" class="modal-close">Cancel</button>
                            <DialogSaveButton 
                            themeSettings={this.props.themeSettings}
                            onClick={this.handleSave} type="button">
                                {this.state.showLoader ? <div class="loader-btn mt-2"></div> : 'Save'}
                            </DialogSaveButton>
                        </div>
                    </div>
                </div>
            </Modal>
            <AlertDialog
                showAlertDialog={this.state.showAlertDialogInfo}
                handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                type={Constants.ALERT_TYPE_ALERT}
                alertDialogMessage={this.state.alertDialogMessageInfo}
                proceedBtnClick={this.handleAlertDialogCloseInfo}
                proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                themeSettings={this.props.themeSettings}
            />
            </>
        );
    }
}

export default HeadingDialog;